import { ArticlesVisibilitySettingsBuilder } from '../../common/articles-visibility/articles-visibility-settings.builder';
import { HomepageComponentTypes } from './widget-kb-module-settings.i';
var WidgetKbModuleSettingsBuilder = /** @class */ (function () {
    function WidgetKbModuleSettingsBuilder() {
        this.widgetKbModuleSettings = {
            title: 'kb title',
            subTitle: 'kb sub title',
            searchboxText: 'searchbox placeholder text',
            searchEnabled: true,
            contentScope: new ArticlesVisibilitySettingsBuilder().build(),
            homepageComponents: [{ type: HomepageComponentTypes.ARTICLES, enabled: true }, { type: HomepageComponentTypes.CATEGORIES, enabled: true }],
            articleIds: []
        };
    }
    WidgetKbModuleSettingsBuilder.prototype.withTitle = function (title) {
        this.widgetKbModuleSettings.title = title;
        return this;
    };
    WidgetKbModuleSettingsBuilder.prototype.withSubTitle = function (subTitle) {
        this.widgetKbModuleSettings.subTitle = subTitle;
        return this;
    };
    WidgetKbModuleSettingsBuilder.prototype.withSearchboxtext = function (searchboxtext) {
        this.widgetKbModuleSettings.searchboxText = searchboxtext;
        return this;
    };
    WidgetKbModuleSettingsBuilder.prototype.withSearchEnabled = function (searchEnabled) {
        this.widgetKbModuleSettings.searchEnabled = searchEnabled;
        return this;
    };
    WidgetKbModuleSettingsBuilder.prototype.withContentScope = function (contentScope) {
        this.widgetKbModuleSettings.contentScope = contentScope;
        return this;
    };
    WidgetKbModuleSettingsBuilder.prototype.withHomepageComponentsList = function (homepageComponents) {
        this.widgetKbModuleSettings.homepageComponents = homepageComponents;
        return this;
    };
    WidgetKbModuleSettingsBuilder.prototype.withArticleIds = function (articleIds) {
        this.widgetKbModuleSettings.articleIds = articleIds;
        return this;
    };
    WidgetKbModuleSettingsBuilder.prototype.build = function () {
        return this.widgetKbModuleSettings;
    };
    return WidgetKbModuleSettingsBuilder;
}());
export { WidgetKbModuleSettingsBuilder };
//# sourceMappingURL=widget-kb-module-settings.builder.js.map